/**
 * Converts a phone number to the +972XXXXXXXXX format
 */
export function phoneToIsraelSignedPhone(phone: string) {
  if (phone?.startsWith("+972")) return phone;
  return "+972" + phone?.slice(1);
}

export function formatPhoneNumber(phone: string) {
  if (phone?.startsWith("05")) return phone;
  return phone?.replace("+972", "0");
}
